import React, { useEffect } from 'react'
import HeroSection from '../../../components/organism/heroSection/index.tsx'
import Navbar from '../../../components/organism/navbar/index.tsx'
// import InfoContent from '../../../components/organism/infoContent/index.tsx'
import './index.css'
import InfoContent from '../../../components/organism/infoContent/index.tsx'
import HowDoesItWork from '../../../components/organism/howDoesItWork/index.tsx'
import FaceFilters from '../../../components/organism/faceFilters/index.tsx'
import Reviews from '../../../components/organism/reviews/index.tsx'
import QuoteSection from '../../../components/organism/quoteSection/index.tsx'
import ContactForm from '../../../components/organism/contactForm/index.tsx'
import Footer from '../../../components/organism/footer/index.tsx'
import PriceSection from '../../../components/organism/priceSection/index.tsx'
import PurchaseFlow from '../../../components/organism/purchaseFlow/index.tsx'
import MarketingSeo from '../../../components/marketingSeo/index.tsx'
import QrAlbum from '../../../components/organism/qrAlbum/index.tsx'

const Home : React.FC = () => {
	// run this function from an event handler or an effect to execute scroll
	useEffect(() => {
		// if (loaderShown) {
		document.querySelector('.body-container')?.classList.add('position-initial')
		// }

		setTimeout(() => {
			window.scrollTo({ top: 0 })
		}, 200)
	}, [])

	return (
		<div className='body-container'>
			<MarketingSeo page='home' />
			<Navbar scrollToContact={() => {}} />
			<HeroSection />
			<QrAlbum />
			<HowDoesItWork />
			<FaceFilters />
			<InfoContent viewType={2}/>
			<Reviews />
			<PriceSection />
			<PurchaseFlow />
			<InfoContent viewType={3}/>
			<QuoteSection/>

			<ContactForm />

			<Footer />
		</div>
	)
}

export default Home
